
import creditnotes from '../api/credit-notes'

export const state = {
  credit_notes: [],
  credit_note_pagination_data: {},
  credit_note: ''
}

export const getters = {
  credit_notes: state => state.credit_notes,
  credit_note_pagination_data: state => state.credit_note_pagination_data,
  credit_note: state => state.credit_note
}

export const mutations = {
  ADD_CREDIT_NOTE (state, data) {
    state.credit_notes.push(data)
  },
  SET_CREDIT_NOTES (state, data) {
    state.credit_notes = data
  },
  SET_CREDIT_NOTE_PAGINATION (state, data) {
    state.credit_note_pagination_data = data
  },
  SHOW_CREDIT_NOTE (state, data) {
    state.credit_note = data
  }
}

export const actions = {
  GET_CREDIT_NOTES ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      creditnotes.get(data).then(response => {
        commit('SET_CREDIT_NOTES', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_CREDIT_NOTE_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_CREDIT_NOTE ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      creditnotes.create(data).then(response => {
        commit('ADD_CREDIT_NOTE', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_CREDIT_NOTE ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      creditnotes.show(id).then(response => {
        commit('SHOW_CREDIT_NOTE', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_CREDIT_NOTE ({ commit, getters }, payload) {
    return new Promise((resolve, reject) => {
      creditnotes.update(payload.data, state.credit_note.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_CREDIT_NOTE ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      creditnotes.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/credit-notes.js